import React from 'react';

//Third party packages
import { Row, Col, Card } from 'react-bootstrap';
import Skeleton from '../../common/skeleton';

const SearchPageSkeleton = () => (
  <>
    <div className="mt-5 desktop-skeleton">
      <div>
        <Card className="p-2">
          <Skeleton count={1} height={150} />
        </Card>
      </div>
    </div>
  </>
);

export default SearchPageSkeleton;
